// units/slice.js

import { unitsInitialState } from "./unitsState";
import { makeUnitsActions } from "./unitsActions";

export const createUnitsSlice = (set, get) => ({
  units: unitsInitialState,
  unitsActions: Object.freeze(makeUnitsActions(set, get)),
});
